import { useAuth } from '../context/AuthContext';
import Navbar from './Navbar';

export default function Layout({ title, children, wide = false }) {
  return (
    <>
      <Navbar />
      <main className="container">
        <div style={{ maxWidth: wide ? 1280 : 960, margin: '0 auto', padding: '24px 20px' }}></div>
        {title && <h1 style={{margin:'16px 0 8px'}}>{title}</h1>}
        {children}
        
      </main>
    </>
  );
}